import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        },
        {
          path: "/attachment",
          component: () => import("@/views/default/_attachment.vue"),
          props: true
        },
        {
          path: "/firstTime",
          component: () => import("@/views/default/_firstTime.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/security",
          component: () => import("@/views/default/_security.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/resetPassword",
          component: () => import("@/views/default/_resetPassword.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/domainSetup",
          component: () => import("@/views/default/_domainSetup.vue"),
          meta: { requiredLoggedIn: true}
        }
      ]
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system/dashboard",
          component: () => import("@/views/system/_dashboard.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true }
        },
      ],
    },
    {
      path: "/account",
      component: () => import("@/views/account/index.vue"),
      children: [
        {
          path: "/account/operator",
          component: () => import("@/views/account/_operator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operator], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/settings",
          component: () => import("@/views/account/_settings.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settings], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/subAccount",
          component: () => import("@/views/account/_subAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subaccount], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/subAccountAdd",
          component: () => import("@/views/account/_subAccountAdd.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subaccountadd], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/ipWhitelist",
          component: () => import("@/views/account/_ipWhitelist.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ipwhitelist], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/operatorsummary",
          component: () => import("@/views/account/_operatorSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operatorsummary], subAccPage: [config.subAccessRoles.account] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operator, config.accessRoles.subaccount, config.accessRoles.subaccountadd, config.accessRoles.ipwhitelist, config.accessRoles.operatorsummary], subAccPage: [config.subAccessRoles.account]}
    },
    {
      path: "/domain",
      component: () => import("@/views/domain/index.vue"),
      children: [
        {
          path: "/domain/domainList",
          component: () => import("@/views/domain/_domainList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.domainop, config.accessRoles.domainlist], subAccPage: [config.subAccessRoles.domain] }
        },
        {
          path: "/domain/domainAvailable",
          component: () => import("@/views/domain/_domainAvailable.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.domainavailable], subAccPage: [config.subAccessRoles.domain] }
        },
        {
          path: "/domain/domainApplication",
          component: () => import("@/views/domain/_domainApplication.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.domainapplication], subAccPage: [config.subAccessRoles.domain] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.domainlist, config.accessRoles.domainop, config.accessRoles.domainavailable, config.accessRoles.domainapplication], subAccPage: [config.subAccessRoles.domain] }
    },
    {
      path: "/ticket",
      component: () => import("@/views/ticket/index.vue"),
      children: [
        {
          path: "/ticket/ticketList",
          component: () => import("@/views/ticket/_ticketList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlist], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/pendingTicket",
          component: () => import("@/views/ticket/_pendingTicket.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.pendingticket], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/ticketListAutoWithdrawal",
          component: () => import("@/views/ticket/_ticketListAutoWithdrawal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistautowithdrawal], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/ticketListReviewAudit",
          component: () => import("@/views/ticket/_ticketListReviewAudit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistreviewaudit], subAccPage: [config.subAccessRoles.ticket] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlist, config.accessRoles.pendingticket, config.accessRoles.ticketlistautowithdrawal, config.accessRoles.ticketlistreviewaudit], subAccPage: [config.subAccessRoles.ticket] }
    },
    {
      path: "/ticketoperator",
      component: () => import("@/views/ticketoperator/index.vue"),
      children: [
        {
          path: "/ticketoperator/ticketListOp",
          component: () => import("@/views/ticketoperator/_ticketListMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistop], subAccPage: [config.subAccessRoles.ticket] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistop], subAccPage: [config.subAccessRoles.ticket] }
    },
    {
      path: "/bank",
      component: () => import("@/views/bank/index.vue"),
      children: [
        {
          path: "/bank/bank",
          component: () => import("@/views/bank/_bank.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankStatement",
          component: () => import("@/views/bank/_bankStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankstatement], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankStatementDaily",
          component: () => import("@/views/bank/_bankStatementDaily.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankstatementdaily], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/payment",
          component: () => import("@/views/bank/_payment.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.paymentproviderco, config.accessRoles.paymentprovidergb], subAccPage: [config.subAccessRoles.bank] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank, config.accessRoles.bankstatement, config.accessRoles.bankstatementdaily, config.accessRoles.paymentproviderco, config.accessRoles.paymentprovidergb], subAccPage: [config.subAccessRoles.bank] },
    },
    {
      path: "/report",
      component: () => import("@/views/report/index.vue"),
      children: [
        {
          path: "/report",
          redirect: "/report/dailyStatement"
        },
        {
          path: "/report/dailyWinLoseGame",
          component: () => import("@/views/report/_dailyWinLoseGame.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlosegame], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/providerWinLoseCompany",
          component: () => import("@/views/report/_providerWinLoseCompany.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerwinlosecompany], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/providerWinLoseOperator",
          component: () => import("@/views/report/_providerWinLoseOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerwinloseoperator], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/providerWinLoseOperatorPt",
          component: () => import("@/views/report/_providerWinLoseOperatorPt.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerwinloseoperatorpt], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyPnlOperator",
          component: () => import("@/views/report/_dailyPnlOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailypnloperator], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailySummaryCompany",
          component: () => import("@/views/report/_dailySummaryCompany.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummarycompany], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailySummaryOperator",
          component: () => import("@/views/report/_dailySummaryOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummaryoperator], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailySummarySMS",
          component: () => import("@/views/report/_dailySummarySMS.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummarysms], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyLedger",
          component: () => import("@/views/report/_dailyLedgerOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailyledger], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/oneTimeDepositor",
          component: () => import("@/views/report/_oneTimeDepositor.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.onetimedepositor], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/currentMonthNonDepositor",
          component: () => import("@/views/report/_currentMonthNonDepositor.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.currentmonthnondepositor], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/currentMonthNoLogin",
          component: () => import("@/views/report/_currentMonthNoLogin.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.currentmonthnologin], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/depositedMember",
          component: () => import("@/views/report/_depositedMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.depositedmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/registeredMember",
          component: () => import("@/views/report/_registeredMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.registeredmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/firstDeposit",
          component: () => import("@/views/report/_firstDeposit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.firstdeposit], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSignupUnused",
          component: () => import("@/views/report/_promotionSignupUnused.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotinosignupunused], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSignupOngoing",
          component: () => import("@/views/report/_promotionSignupOngoing.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotinosignupongoing], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSignupWinlose",
          component: () => import("@/views/report/_dailyWinloseSBOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotinosignupwinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSummary",
          component: () => import("@/views/report/_promotionSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotinosummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionWithdrawalSummary",
          component: () => import("@/views/report/_promotionWithdrawalSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionwithdrawalsummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rebateSummary",
          component: () => import("@/views/report/_rebateSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rebatesummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rebateMember",
          component: () => import("@/views/report/_rebateMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rebatemember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rescueFundSummary",
          component: () => import("@/views/report/_rescueFundSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rescuefundsummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/themepurchased",
          component: () => import("@/views/report/_themePurchased.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.themepurchased], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/totalPlayedMiniGame",
          component: () => import("@/views/report/_totalPlayedMiniGame.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.totalplayedminigame], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/totalMiniGameCoinUsed",
          component: () => import("@/views/report/_totalMiniGameCoinUsed.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.totalminigamecoinused], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/totalMiniGameReward",
          component: () => import("@/views/report/_totalMiniGameReward.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.totalminigamereward], subAccPage: [config.subAccessRoles.report] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummaryoperator, config.accessRoles.dailyledger,
              config.accessRoles.dailywinlosegame,
              config.accessRoles.providerwinloseoperator, config.accessRoles.providerwinloseoperatorpt, config.accessRoles.currentmonthnologin, config.accessRoles.currentmonthnondepositor,
              config.accessRoles.depositedmember, config.accessRoles.registeredmember, config.accessRoles.firstdeposit,
              config.accessRoles.onetimedepositor, config.accessRoles.promotinosignupunused, config.accessRoles.promotinosignupongoing, config.accessRoles.promotinosignupwinlose, config.accessRoles.promotinosummary, config.accessRoles.promotionwithdrawalsummary, config.accessRoles.rebatesummary, config.accessRoles.rebatemember, config.accessRoles.rescuefundsummary, config.accessRoles.dailysummarysms,
              config.accessRoles.themepurchased, config.accessRoles.totalplayedminigame, config.accessRoles.totalminigamecoinused, config.accessRoles.totalminigamereward], subAccPage: [config.subAccessRoles.report] }
    },
    {
      path: "/log",
      component: () => import("@/views/log/index.vue"),
      children: [
        {
          path: "/log/gamenameexlog",
          component: () => import("@/views/log/_gameNameExLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gamenameexlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/adjustmentLog",
          component: () => import("@/views/log/_adjustmentLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmentlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/bonusLog",
          component: () => import("@/views/log/_issueBonusLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bonuslog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/memberLoginLog",
          component: () => import("@/views/log/_loginMemberLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberloginlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/resultChangesLog",
          component: () => import("@/views/log/_gameResultChangesLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.resultchangeslog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/vipLog",
          component: () => import("@/views/log/_memberVipLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.viplog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/membertokenlog",
          component: () => import("@/views/log/_memberTokenLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.membertokenlog], subAccPage: [config.subAccessRoles.log] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gamenameexlog, config.accessRoles.adjustmentlog, config.accessRoles.bonuslog, config.accessRoles.memberloginlog, config.accessRoles.resultchangeslog, config.accessRoles.viplog, config.accessRoles.membertokenlog], subAccPage: [config.subAccessRoles.log] },
    },
    {
      path: "/affiliate",
      component: () => import("@/views/affiliate/index.vue"),
      children: [
        {
          path: "/affiliate/affiliateList",
          component: () => import("@/views/affiliate/_affiliateList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatelist], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyWinLoseAffiliate",
          component: () => import("@/views/affiliate/_dailyWinLoseAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatelist], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyDepositAffiliate",
          component: () => import("@/views/affiliate/_dailyDepositAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatelist], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/affiliateReport",
          component: () => import("@/views/affiliate/_affiliateReport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatelist], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/approveAffiliate",
          component: () => import("@/views/affiliate/_approveAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.approveaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/ticketListAffiliate",
          component: () => import("@/views/affiliate/_ticketListAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/pendingTicketAffiliate",
          component: () => import("@/views/affiliate/_pendingTicketAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.pendingticketaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/adjustmentLogAffiliate",
          component: () => import("@/views/affiliate/_adjustmentLogAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmentlogaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyWinLoseAffiliate",
          component: () => import("@/views/affiliate/_dailyWinLoseAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinloseaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyDepositAffiliate",
          component: () => import("@/views/affiliate/_dailyDepositAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailydepositaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/affiliateReport",
          component: () => import("@/views/affiliate/_affiliateReport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatereport], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/ticketListReviewAuditAffiliate",
          component: () => import("@/views/affiliate/_ticketListReviewAuditAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistreviewauditaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.approveaffiliate, config.accessRoles.affiliatelist, config.accessRoles.bankaffiliate,
                                                      config.accessRoles.ticketaffiliate, config.accessRoles.playerlist,
                                                      config.accessRoles.dailywinloseaffiliate, config.accessRoles.dailywinlosememberaffiliate, config.accessRoles.commupdatelogaffiliate, config.accessRoles.affiliatereport], subAccPage: [config.subAccessRoles.affiliate] }
    },
    {
      path: "/site",
      component: () => import("@/views/site/index.vue"),
      children: [
        {
          path: "/site/newwebsite",
          component: () => import("@/views/site/_newWebsite.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.newwebsite], subAccPage: [config.subAccessRoles.site] }
        },
        {
          path: "/site/operatorinformation",
          component: () => import("@/views/site/_operatorInformation.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operatorinformation], subAccPage: [config.subAccessRoles.site] }
        },
        {
          path: "/site/sitelist",
          component: () => import("@/views/site/_siteList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sitelist], subAccPage: [config.subAccessRoles.site] }
        },
        {
          path: "/site/siteinfo",
          component: () => import("@/views/site/_siteInfo.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.siteinfo], subAccPage: [config.subAccessRoles.site] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.sitelist, config.accessRoles.siteinfo, config.accessRoles.newwebsite, config.accessRoles.operatorinformation], subAccPage: [config.subAccessRoles.site] },
    },
    {
      path: "/content",
      component: () => import("@/views/content/index.vue"),
      children: [
        {
          path: "/content/bodefaultdomain",
          component: () => import("@/views/content/_bodefaultdomain.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bodefaultdomain], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/package",
          component: () => import("@/views/content/_package.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.package], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/language",
          component: () => import("@/views/content/_language.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.language], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/themeprovider",
          component: () => import("@/views/content/_themeProvider.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.themeprovider], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/themecontent",
          component: () => import("@/views/content/_themeContent.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.themecontent], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/themecontentgroup",
          component: () => import("@/views/content/_themeContentGroup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.themecontentgroup], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/themecontentposition",
          component: () => import("@/views/content/_themeContentPosition.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.themecontentposition], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/theme",
          component: () => import("@/views/content/_theme.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.theme], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/defaulttemplate",
          component: () => import("@/views/content/_defaultTemplate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.defaulttemplate], subAccPage: [config.subAccessRoles.content] }
        },
        {
          path: "/content/minigame",
          component: () => import("@/views/content/_miniGame.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.minigame], subAccPage: [config.subAccessRoles.content] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.package,
        config.accessRoles.bodefaultdomain, config.accessRoles.language, config.accessRoles.themeprovider, config.accessRoles.themecontent,
        config.accessRoles.themecontentgroup, config.accessRoles.themecontentposition, config.accessRoles.theme,
        config.accessRoles.defaulttemplate, config.accessRoles.minigame], subAccPage: [config.subAccessRoles.content] }
    },
    {
      path: "/globalsetting",
      component: () => import("@/views/globalsetting/index.vue"),
      children: [
        {
          path: "/globalsetting/providerMaintenance",
          component: () => import("@/views/globalsetting/_providerMaintenance.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providermaintenance], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/profileSetting",
          component: () => import("@/views/globalsetting/_profileSetting.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.profilesetting], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/socialPlatformLookup",
          component: () => import("@/views/globalsetting/_socialPlatformLookup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.socialplatformlookup], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/exchangeRate",
          component: () => import("@/views/globalsetting/_exchangeRate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.exchangerate], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/paymentOption",
          component: () => import("@/views/globalsetting/_paymentOption.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.paymentoption], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/providerPtGlobal",
          component: () => import("@/views/globalsetting/_providerPtGlobal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerptglobal], subAccPage: [config.subAccessRoles.globalsetting] }
        },
        {
          path: "/globalsetting/gamifyGlobal",
          component: () => import("@/views/globalsetting/_gamifyGlobal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gamifyglobal], subAccPage: [config.subAccessRoles.globalsetting] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providermaintenance,config.accessRoles.profilesetting,
              config.accessRoles.socialplatformlookup, config.accessRoles.exchangerate, config.accessRoles.providerptglobal, config.accessRoles.gamifyglobal], subAccPage: [config.subAccessRoles.globalsetting] }
    },
  ]
});

export default router;
